import * as JournalEntryConstants from "../constants";

const initialState = {
  list: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
  case JournalEntryConstants.JOURNAL_ENTRY_SUCCESS:
    return {
      ...state,
      list: action.payload
    };
  default:
    return state;
  }
}